import React, { Component } from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-1218">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1219">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1220">
          <div className="col-span-1 md:col-span-2" data-id="element-1221">
            <div className="flex items-center gap-2 mb-4" data-id="element-1222">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-1223">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-1224">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-1225">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-1226">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-1227">
            <h4 className="font-semibold text-white mb-4" data-id="element-1228">Explorar</h4>
            <ul className="space-y-3" data-id="element-1229">
              <li data-id="element-1230">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1231">
                  Inicio
                </Link>
              </li>
              <li data-id="element-1232">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1233">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-1234">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1235">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-1236">
            <h4 className="font-semibold text-white mb-4" data-id="element-1237">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-1238">
              <li data-id="element-1239">
                <Link to="/onboarding" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1240">
                  Únete a NOIZA
                </Link>
              </li>

              <li data-id="element-1241">
                <a href={`https://wa.me/50685316690?text=${encodeURIComponent('Hola, requiero soporte con: _________\n\nNombre del restaurante:\nCorreo electrónico registrado:\nNombre de quien contacta:')}`} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-1242">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-1243">
          <p className="text-white/30 text-sm" data-id="element-1244">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-1245">
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1246">
              Términos
            </Link>
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-1247">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}